import React from 'react';
import './App.css';
import '@fontsource/inter/400.css';  // Regular
import '@fontsource/inter/500.css';  // Medium
import '@fontsource/inter/600.css';  // Semi-bold
import '@fontsource/inter/700.css';  // Bold
import '@fontsource/inter/800.css';  // Extra-bold
import '@fontsource/inter/900.css';  // Black
import '@fontsource/rubik';
import '@fontsource/sora'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Import components
import Nav from './components/Nav/Nav';
import Hero from './components/Hero/Hero';
import Partners from './components/Partners/Partners';
import SolanaPowered from './components/SolanaPowered/SolanaPowered';
import UseCases from './components/UseCases/UseCases';
import WhyGambleBase from './components/WhyGambleBase/WhyGambleBase';
import DeveloperPlayground from './components/DeveloperPlayground/DeveloperPlayground';
import Ecosystem from './components/Ecosystem/Ecosystem';
import Footer from './components/Footer/Footer';

const showComingSoon = () => {
  toast.info('🚀 Coming Soon!', {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    style: {
      background: 'rgba(10, 15, 31, 0.95)',
      border: '1px solid rgba(114, 43, 255, 0.2)',
      borderRadius: '8px',
      color: '#fff',
    },
  });
};

function App() {
  return (
    <div className="App">
      <Nav />
      <Hero />
      <Partners />
      <SolanaPowered />
      <UseCases />
      <WhyGambleBase />
      <DeveloperPlayground />
      <Ecosystem />
      <Footer />
      <ToastContainer />
    </div>
  );
}

export { showComingSoon };
export default App;
